import { z } from 'zod';
import { nonEmptyStringSchema } from '@zealy/utils';
import { updateTokenRewardTransactionSchema } from './updateTokenRewardTransaction';
export const updateTokenRewardsTransactionSchema = z.array(updateTokenRewardTransactionSchema);
export const updateTokenRewardsTransactionBodySchema = z.object({
    ids: z.array(nonEmptyStringSchema),
    transactionId: nonEmptyStringSchema,
});
